// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605271503/js/" + chunkId + "." + {"44":"f159faee","225":"ce69cd30","481":"17eb048e","486":"a006531b","770":"c656040c"}[chunkId] + ".0.7763093022137029.chunk.js";
};